export default __webpack_public_path__ + "static/media/img-5.a5afcad1.jpg";